import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const dateTimeFormats = {
	en: {
		short: {
			year: "numeric",
			month: "short",
			day: "numeric",
		},
		long: {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		},
	},
	ja: {
		short: {
			year: "numeric",
			month: "short",
			day: "numeric",
		},
		long: {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		},
	},
};

// Transform translation structure for proper access
const translations = {};
if (window.webinars_data.translation && window.webinars_data.translation.dictionary && window.webinars_data.translation.dictionary.default) {
	// Copy translations from nested structure to top level
	Object.assign(translations, window.webinars_data.translation.dictionary.default);
}

// Create VueI18n instance with options
export default new VueI18n({
	locale: "default",
	fallbackLocale: "default",
	silentFallbackWarn: true,
	messages: { default: translations },
	dateTimeFormats,
});
